import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConnections,
  defaultConstruction,
  defaultCosts,
  defaultDescription,
  defaultGastronomyBasicInfo,
  defaultGastronomyOtherFacilities,
  defaultObjectNumbers,
  useManualAndInternationalAddress,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentGastronomyRentSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  costs: { ...defaultCosts, courtageNote: validationRules.courtageNote, courtage: validationRules.courtage },
  basicInfo: defaultGastronomyBasicInfo,
  otherFacilities: defaultGastronomyOtherFacilities,
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  construction: defaultConstruction,
  objectNumbers: defaultObjectNumbers,
  connections: defaultConnections,
  apiSearchData: defaultApiSearchData,
}
